import { callApi } from 'loankeeper-common/api'

// export const search = (params) =>
//   callApi('acc_entry_search', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const details = ({ ID, hash, OperTypeID, page, ...rest }) =>
  callApi('acc_entry_view', {
    params: {
      EntryID: ID,
      HashSum_EntryID_: hash,
      page,
      OperTypeID,
      ...rest,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const comments = ({ Comment, OperTypeID, action, ID }) =>
//   callApi('acc_entry_comments', {
//     params: {
//       action,
//       OperTypeID,
//       Comment,
//       ID,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const operations = ({ ID, hash, OID, OIDHash, ...rest }) =>
//   callApi('acc_entry_oper', {
//     params: {
//       ID,
//       HashSum_EntryID_: hash,
//       OID,
//       HashSum_OID_: OIDHash,
//       ...rest,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deleteOrder = (body) =>
//   callApi('acc_entry_add', {
//     params: {
//       action: 'delete',
//     },
//     body,
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const orderRate = (params) =>
//   callApi('rate_view', {
//     params: {
//       action: 'live',
//       ...params,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const add = ({
  action,
  EntryID,
  MoneyTransferCountryID,
  MoneyTransferSystemID,
  MoneyTransferCode,
  MTA_FullName,
  MTA_Address,
  MTA_DOB,
  MTA_BirthPlace,
  MTA_DocNo,
  ...rest
}) =>
  callApi('acc_entry_add', {
    params: {
      action,
    },
    body: {
      ...rest,
      EntryID,
      MoneyTransferCountryID,
      MoneyTransferSystemID,
      MoneyTransferCode,
      MTA_FullName,
      MTA_Address,
      MTA_DOB,
      MTA_BirthPlace,
      MTA_DocNo,
    },
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const addConv = (params, body) =>
//   callApi('acc_conv_add', {
//     params,
//     body,
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const print = (params) =>
  callApi('acc_entry_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
